import type { HttpPost, HttpRequest } from '@/shared/infra/http'
import { mapServerError } from '@/shared/infra/http'
import type { ProCheckoutSession } from '@/shared/domain'
import type { CreateProCheckoutSession } from '@/modules/auth/use-cases'

export class EdgeCreateProCheckoutSessionRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: CreateProCheckoutSession = async (params) => {
    const body = {
      plan: params.plan,
      successUrl: params.successUrl,
      cancelUrl: params.cancelUrl,
      ...(params.promoCode ? { promoCode: params.promoCode } : {}),
      ...(params.source ? { source: params.source } : {}),
    }
    const request: HttpRequest<typeof body> = {
      url: '/pro-billing/checkout-session',
      body,
    }
    try {
      return await this.httpClient.post<typeof body, ProCheckoutSession>(request)
    } catch (err) {
      mapServerError(err)
    }
  }
}
